// extracted by mini-css-extract-plugin
export default {"leaderboardWrapper":"Leaderboard_leaderboardWrapper__nfsae","leaderboardNavigation":"Leaderboard_leaderboardNavigation__1b1B5","register":"Leaderboard_register__WF6xB"};